import { createDecorator } from '../../../../platform/instantiation/common/instantiation.js';
const IInlineChatSavingService = ( createDecorator('IInlineChatSavingService	'));
export { IInlineChatSavingService };
